export default {
  loadedActionPlans (state) {
    return state.actionPlans.map(actionPlan => actionPlan.id)
  }
}
